import _ from "lodash";
import { BackendResponse } from "../api/BackendResponse";
import {
  CODE_NOT_LOGGED_IN_NEXT,
  CODE_NOT_LOGGED_IN_VISMA,
} from "../api/CUSTOM_STATUS_CODES";
import { wsSentryReport } from "./wsSentryReport";

export interface IWsSentryReportArgs {
  error?: any;
  tag?: string;
  showDialog?: boolean;
  dialogTitle?: string;
  simpleMessage: string;
  correlationId?: string;
  alreadyReported?: boolean;
  additionalErrorMessageInfo?: any[];
  [x: string]: any;
}

export interface SentryAssertDataOptions {
  mapSentryData?: (data: BackendResponse) => BackendResponse;
}

export const sentryAssertData = (
  data: BackendResponse | BackendResponse[],
  options: SentryAssertDataOptions
) => {
  let datas: BackendResponse[] = [];
  if (!Array.isArray(data)) datas = [data];
  else datas = data;

  const { mapSentryData: _mapSentryData } = options;

  const mapSentryData = (data: BackendResponse) => {
    if (_mapSentryData) {
      try {
        return _mapSentryData(data);
      } catch (e) {}
    }

    return data;
  };

  datas = datas.map(mapSentryData);

  const withError = datas.filter((data) => data && !data.ok);

  if (withError.length > 0) {
    dataErrorsQueuedForDialog.push(...withError.map((data) => ({ data })));
    showSentryReportSoon();
  }
};

interface DataError {
  data: BackendResponse;
}
let dataErrorsQueuedForDialog: DataError[] = [];

const showSentryReportSoon = _.debounce(() => {
  let reportNow = [...dataErrorsQueuedForDialog];
  dataErrorsQueuedForDialog = [];

  reportNow = reportNow.filter((d) => {
    const isNotLoggedInError = [
      CODE_NOT_LOGGED_IN_NEXT,
      CODE_NOT_LOGGED_IN_VISMA,
    ].includes(d.data.statusCode);

    if (!isNotLoggedInError) {
      return true;
    }

    return true;
  });

  if (reportNow.length > 0) {
    const messages = _.uniq(reportNow.map((d) => d.data.message));

    wsSentryReport({
      simpleMessage: messages.join("\n"),
      error: messages.join("\n"),
      data: reportNow,
      showDialog: true,
    });
  }
}, 1000);
